var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoad)?_c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.allScreen)?_c('container',[_c('keep-alive',[(_vm.$route.meta.auth)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.auth)?_c('router-view'):_vm._e()],1):_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }